export default function init() {
	// noinspection MagicNumberJS
	class EVENTSGMAP {
		static SELECTOR_CLASS_EVENTS = '.wp-block-jtf-jtf-events'
		static SELECTOR_CLASS_GMAP = '.jtf__eventsblock--gmap'
		static ATTR_GMOM = 'data-gmom'
		static ATTR_ADDRESS = 'data-address'
		static PROP_OPEN = 'open'
		static PROP_OK = 'OK'
		static ZOOM_LEVEL = 16
		static DEFAULT_LAT = -34.397
		static DEFAULT_LNG = 150.644
		static OPENSTREETMAP_URL = 'https://nominatim.openstreetmap.org/search?format=json&q='
		static TILE_LAYER_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'

		constructor( context, id ) {
			this.geocoder = null
			this.gmom = context.getAttribute( EVENTSGMAP.ATTR_GMOM )
			this.id = id
			this.context = context
			this.map = null
			this.init()
		}

		async getCoords() {
			const address = this.context.getAttribute( EVENTSGMAP.ATTR_ADDRESS )

			try {
				const response = await fetch( EVENTSGMAP.OPENSTREETMAP_URL + address )
				const data = await response.json()
				this.renderOpenMap( data )
			} catch ( error ) {
				// Error handling
			}
		}

		renderOpenMap( coords ) {
			const location = [ coords[ 0 ].lat, coords[ 0 ].lon ]
			const mapOptions = {
				center: location,
				zoom: EVENTSGMAP.ZOOM_LEVEL,
			}

			const map = new L.map( this.id, mapOptions )
			const layer = new L.TileLayer( EVENTSGMAP.TILE_LAYER_URL )

			L.marker( location ).addTo( map )
			map.addLayer( layer )
		}

		init() {
			if ( this.gmom === EVENTSGMAP.PROP_OPEN ) {
				this.getCoords().then( () => {} )
			} else {
				this.geocoder = new google.maps.Geocoder()
				const latlng = new google.maps.LatLng( EVENTSGMAP.DEFAULT_LAT, EVENTSGMAP.DEFAULT_LNG )
				const mapOptions = {
					zoom: EVENTSGMAP.ZOOM_LEVEL,
					center: latlng,
				}
				this.map = new google.maps.Map( document.getElementById( this.id ), mapOptions )
				this.codeAddress()
			}
		}

		codeAddress() {
			const address = document.getElementById( this.id ).getAttribute( EVENTSGMAP.ATTR_ADDRESS )

			this.geocoder.geocode( { 'address': address }, ( results, status ) => {
				if ( status === EVENTSGMAP.PROP_OK ) {
					this.map.setCenter( results[ 0 ].geometry.location )
					new google.maps.Marker( {
						map: this.map,
						position: results[ 0 ].geometry.location,
					} )
				}
				} )
		}
	}

	const eventsBlocks = document.querySelectorAll( EVENTSGMAP.SELECTOR_CLASS_EVENTS )
	if ( eventsBlocks.length > 0 ) {
		const gmapBlocks = document.querySelectorAll( EVENTSGMAP.SELECTOR_CLASS_GMAP )
		gmapBlocks.forEach( ( block ) => {
			const id = block.getAttribute( 'id' )
			new EVENTSGMAP( block, id )
		} )
	}
}
